export default "__VITE_ASSET__igNhgmfY__"